import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';

import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { TooltipChartComponent } from './components/tooltip-chart/tooltip-chart.component';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { BpCoreModule } from '@bp-core/src/public-api';
import { BpAlertComponent } from '@bp-core/src/lib/components/alert/bp-alert.component';
import {
  BpAlertIconDirective,
  BpAlertTitleDirective,
} from '@bp-core/src/lib/components/alert/bp-alert.directives';
import { BpEndFlowComponent } from '@bp-core/src/lib/components/bp-end-flow/bp-end-flow.component';
import { FloatingSectionTabsComponent } from '@bp-core/src/lib/components/floating-section-tabs/floating-section-tabs.component';
import { PageTitleBackComponent } from '@bp-core/src/lib/components/page-title-back/page-title-back.component';
import { SegmentedControlComponent } from '@bp-core/src/lib/components/segmented-control/segmented-control.component';
import { FuseAlertComponent } from '../../../../shared/src/template/@fuse/components/alert/alert.component';
import { ActivitiesFilterChipsComponent } from './components/activities-filter-chips/activities-filter-chips.component';
import { ActivitiesGroupFilterComponent } from './components/activities-group-filter/activities-group-filter.component';
import { CurrencySelectComponent } from './components/currency-select/currency-select.component';
import { GoalActivityComponent } from './components/goal-activity/goal-activity.component';
import { GoalFilterSelectComponent } from './components/goal-filter-select/goal-filter-select.component';
import { OperationTypeSelectComponent } from './components/operation-type-select/operation-type-select.component';
import { TimePeriodSelectComponent } from './components/time-period-select/time-period-select.component';

// Los componentes, directivas y servicios sin uso que declaraba este módulo se borraron en la 070
// (T050, FR-027): quedan solo los que usa una pantalla viva.
@NgModule({
  declarations: [
    TooltipChartComponent,
    GoalFilterSelectComponent,
    ActivitiesGroupFilterComponent,
    ActivitiesFilterChipsComponent,
    CurrencySelectComponent,
    TimePeriodSelectComponent,
    OperationTypeSelectComponent,
    GoalActivityComponent,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgScrollbarModule,
    MatDialogModule,
    MatButtonModule,
    MatRippleModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    MatRadioModule,
    MatChipsModule,
    MatAutocompleteModule,
    NgxMatSelectSearchModule,
    MatMomentDateModule,
    MatToolbarModule,
    MatStepperModule,
    ReactiveFormsModule,
    NgxLoadingModule,
    MatDividerModule,
    MatTabsModule,
    MatSortModule,
    MatTableModule,
    MatButtonToggleModule,
    TooltipChartComponent,
    GoalFilterSelectComponent,
    ActivitiesGroupFilterComponent,
    ActivitiesFilterChipsComponent,
    CurrencySelectComponent,
    TimePeriodSelectComponent,
    OperationTypeSelectComponent,
    GoalActivityComponent,
    // Piezas standalone de bp-core del catálogo (070, T051, D5): se importan una vez aquí para
    // que los lotes de US6 las usen sin tocar módulos. `users.module.ts` las recibe por este módulo.
    SegmentedControlComponent,
    PageTitleBackComponent,
    FloatingSectionTabsComponent,
    BpAlertComponent,
    BpAlertTitleDirective,
    BpAlertIconDirective,
    BpEndFlowComponent,
  ],
  // `BpConfirmationService` no va acá: es `providedIn: 'root'` (bp-core). Listado en un módulo que
  // importan módulos lazy y componentes standalone, cada uno armaba su propia instancia, distinta de
  // la que resuelve `BP_CONFIRMATION_SERVICE` (070, T047).
  providers: [CurrencyPipe],
  imports: [
    MatPaginatorModule,
    MatTableModule,
    CommonModule,
    RouterModule,
    FormsModule,
    NgScrollbarModule,
    MatDialogModule,
    MatButtonModule,
    MatRippleModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    MatRadioModule,
    MatChipsModule,
    MatAutocompleteModule,
    NgxMatSelectSearchModule,
    MatMomentDateModule,
    MatToolbarModule,
    MatStepperModule,
    ReactiveFormsModule,
    NgxLoadingModule,
    MatDividerModule,
    MatTabsModule,
    BpCoreModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatCheckboxModule,
    FuseAlertComponent,
    MatSlideToggleModule,
    MatSliderModule,
    SegmentedControlComponent,
    PageTitleBackComponent,
    FloatingSectionTabsComponent,
    BpAlertComponent,
    BpAlertTitleDirective,
    BpAlertIconDirective,
    BpEndFlowComponent,
  ],
})
export class SharedModule {}
